import React from 'react';
import logger from '../../utils/logger';
import MessageBubble from '../MessageBubble';
import { ActorType } from '../../enums/conversation';

interface Props {
    children: React.ReactNode;
}

interface State {
    hasError: boolean;
}

class MessageErrorBoundary extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
        logger({
            id: 'MESSAGE-ERROR-BOUNDARY',
            error: error.message || 'Unknown error',
            errorStack: error.stack || null,
            componentStack: errorInfo.componentStack || null,
        });
    }

    render() {
        const { hasError } = this.state;
        const { children } = this.props;

        if (hasError) {
            return (
                <div className='flex flex-col gap-5 pr-40 pl-20'>
                    <MessageBubble actor={{ type: ActorType.BOT }}>
                        Something went wrong while processing your request.
                    </MessageBubble>
                </div>
            );
        }

        return children;
    }
}

export default MessageErrorBoundary;
